import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Box, Typography } from '@mui/material';



const PercentageBar = ({ value }) => {
  // Parse the percentage value
  const percentage = typeof value === 'string' ? 
    parseFloat(value.replace('%', '')) : 
    parseFloat(value);
  
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
      <Box sx={{ position: 'relative', width: '100%', height: '8px' }}>
        <Box
          sx={{
            position: 'absolute',
            left: 0,
            width: `${percentage}%`,
            maxWidth: '90%', // Limit width to leave space for text
            height: '8px',
            backgroundColor: '#2e7bf6',
            borderRadius: '4px',
          }}
        />
      </Box>
      <Typography 
        variant="body2" 
        sx={{ 
          marginLeft: '8px',
          minWidth: '40px',
          textAlign: 'right'
        }}
      >
        {`${percentage}%`}
      </Typography>
    </Box>
  );
};



const Frequency = ({ value }) => {
  // Get color based on frequency label
  const getFrequencyColor = (label) => {
    switch (label) {
      case "Weekly or More":
      case "Almost Weekly":
        return {
          bg: "#E6F0FF",  // Light blue background
          text: "#1A56DB", // Darker blue text
          dot: "#4285F4"   // Original blue for the dot
        };
      case "Bi-Weekly":
        return {
          bg: "#F3E5F5",   // Light purple background
          text: "#6A1B9A",  // Darker purple text
          dot: "#9C27B0"    // Original purple for the dot
        };
      case "Monthly":
        return {
          bg: "#FCE4EC",   // Light pink background
          text: "#B71C50",  // Darker pink text
          dot: "#E91E63"    // Original pink for the dot
        };
      case "Few Times a Year":
      case "Rarely or Never":
      default:
        return {
          bg: "#F5F5F5",   // Light gray background
          text: "#616161",  // Darker gray text
          dot: "#9E9E9E"    // Original gray for the dot
        };
    }
  };

  // Get the appropriate colors
  const colors = getFrequencyColor(value);

  // Inline styles for the container
  const containerStyle = {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: colors.bg,
    padding: '4px 8px',
    borderRadius: '4px',
    display: 'inline-flex'
  };


  // Inline styles for the text
  const textStyle = {
    fontSize: '14px',
    color: colors.text,
  };

  return (
    <div style={containerStyle}>
      <span style={textStyle}>{value}</span>
    </div>
  );
};



export function UI_Table({rows, titles, maxHeight=280}) {
    const headerStyle = {
        fontFamily: '"Source Sans Pro", Sans-serif',
        fontSize: '15px',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.27,
        letterSpacing: 'normal',
        color: '#000000',
      };
      const renderCellContent = (row, columnDef) => {
        switch(columnDef.type) {
          case 'percentage':
            return <PercentageBar value={row[columnDef.key]} />;
          case 'frequency':
            return <Frequency value={row[columnDef.key]} />;
          default:
            return row[columnDef.key];
        }
      };
    return (
      <TableContainer component={Paper} style={{ maxHeight }}>
        <Table sx={{}} aria-label="simple table" stickyHeader >
          <TableHead >
            <TableRow>
              {(titles).map((e) => <TableCell style={{...headerStyle,  fontWeight: 600, backgroundColor: '#f8f8f9' }} key={e.title} >{e.title}</TableCell>)}
            </TableRow>
          </TableHead>
          <TableBody>
          {rows.map((row) => (
            <TableRow
              key={row._id}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              {titles.map((e) => (
                <TableCell 
                  style={headerStyle} 
                  key={e.key}
                >
                  {renderCellContent(row, e)}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
        </Table>
      </TableContainer>
    );
  }
  